<template>
  <div class="derslig-dialog-overlay" v-if="visible" @click="onBackdropClick">
    <div class="derslig-dialog" :class="type" @click.stop>
      <div class="derslig-dialog-icon" v-if="showIcon">
        <div class="icon-container">
          <InfoIcon v-if="type === 'info'" />
          <SuccessIcon v-if="type === 'success'" />
          <ErrorIcon v-if="type === 'error' || type === 'danger'" />
          <WarningIcon v-if="type === 'warning'" />
          <DeleteIcon v-if="type === 'delete'" />
        </div>
      </div>
      <div class="derslig-dialog-content">
        <div class="derslig-dialog-heading" v-if="heading">{{ heading }}</div>
        <div class="derslig-dialog-text" v-html="text"></div>
        <div class="derslig-dialog-buttons">
          <button
            v-if="showCancelButton"
            class="derslig-dialog-button cancel-button"
            @click="onCancel"
          >
            {{ cancelButtonText }}
          </button>
          <button
            class="derslig-dialog-button confirm-button"
            :class="type"
            @click="onConfirm"
          >
            {{ confirmButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InfoIcon from '../toast/icon/InfoIcon.vue';
import SuccessIcon from '../toast/icon/SuccessIcon.vue';
import ErrorIcon from '../toast/icon/ErrorIcon.vue';
import WarningIcon from '../toast/icon/WarningIcon.vue';
import DeleteIcon from './icon/DeleteIcon.vue';

export default {
  name: "ConfirmDialog",
  components: {
    InfoIcon,
    SuccessIcon,
    ErrorIcon,
    WarningIcon,
    DeleteIcon
  },
  props: {
    heading: {
      type: String,
      default: null
    },
    text: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'info',
      validator: function(value) {
        return ['info', 'success', 'error', 'warning', 'danger', 'delete'].indexOf(value) !== -1;
      }
    },
    confirmButtonText: {
      type: String,
      default: 'Tamam'
    },
    cancelButtonText: {
      type: String,
      default: 'İptal'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    closeOnBackdropClick: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: true,
      scrollbarWidth: 0,
      bodyPaddingRight: 0
    };
  },
  mounted() {
    this.lockBodyScroll();
    document.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    this.unlockBodyScroll();
    document.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    onConfirm() {
      this.$emit('confirm');
      this.close();
    },
    onCancel() {
      this.$emit('cancel');
      this.close();
    },
    onBackdropClick() {
      if (this.closeOnBackdropClick) {
        this.onCancel();
      }
    },
    handleKeyDown(e) {
      if (e.key === 'Escape') {
        this.onCancel();
      } else if (e.key === 'Enter') {
        this.onConfirm();
      }
    },
    close() {
      this.visible = false;
      this.$emit('close');
    },
    // Hesapla scrollbar genişliğini
    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    },
    // Body scroll kilit
    lockBodyScroll() {
      this.scrollbarWidth = this.getScrollbarWidth();
      this.bodyPaddingRight = parseInt(window.getComputedStyle(document.body).paddingRight || '0', 10);
      
      if (this.scrollbarWidth > 0) {
        document.body.style.paddingRight = `${this.bodyPaddingRight + this.scrollbarWidth}px`;
        document.body.classList.add('dialog-open');
      }
      
      document.body.style.overflow = 'hidden';
    },
    // Body scroll kilit aç
    unlockBodyScroll() {
      document.body.style.paddingRight = `${this.bodyPaddingRight}px`;
      document.body.classList.remove('dialog-open');
      document.body.style.overflow = '';
    }
  }
}
</script>

<style scoped>
.derslig-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.derslig-dialog {
  display: flex;
  width: 90%;
  max-width: 440px;
  padding: 20px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  animation: dialogFadeIn 0.3s ease;
  position: relative;
}

.derslig-dialog::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 6px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.derslig-dialog.info::before {
  background-color: #3498db;
}

.derslig-dialog.success::before {
  background-color: #2ecc71;
}

.derslig-dialog.error::before,
.derslig-dialog.danger::before {
  background-color: #e74c3c;
}

.derslig-dialog.warning::before {
  background-color: #f39c12;
}

.derslig-dialog.delete::before {
  background-color: #e74c3c;
}

.derslig-dialog-icon {
  flex: 0 0 40px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-right: 16px;
  padding-top: 4px;
}

.icon-container {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.derslig-dialog.info .derslig-dialog-icon {
  color: #3498db;
}

.derslig-dialog.success .derslig-dialog-icon {
  color: #2ecc71;
}

.derslig-dialog.error .derslig-dialog-icon,
.derslig-dialog.danger .derslig-dialog-icon {
  color: #e74c3c;
}

.derslig-dialog.warning .derslig-dialog-icon {
  color: #f39c12;
}

.derslig-dialog.delete .derslig-dialog-icon {
  color: #e74c3c;
}

.derslig-dialog-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.derslig-dialog-heading {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 8px;
  color: #333;
}

.derslig-dialog-text {
  margin-bottom: 16px;
  font-size: 15px;
  line-height: 1.5;
  color: #555;
}

.derslig-dialog-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}

.derslig-dialog-button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.cancel-button {
  background-color: #f1f1f1;
  color: #555;
}

.cancel-button:hover {
  background-color: #e1e1e1;
}

.confirm-button {
  background-color: #3498db;
  color: white;
}

.confirm-button.info {
  background-color: #3498db;
}

.confirm-button.success {
  background-color: #2ecc71;
}

.confirm-button.error,
.confirm-button.danger {
  background-color: #e74c3c;
}

.confirm-button.warning {
  background-color: #f39c12;
}

.confirm-button.delete {
  background-color: #e74c3c;
}

.confirm-button:hover {
  opacity: 0.9;
}

@keyframes dialogFadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 576px) {
  .derslig-dialog {
    width: calc(100% - 32px);
    padding: 16px;
  }
  
  .derslig-dialog-heading {
    font-size: 16px;
  }
  
  .derslig-dialog-text {
    font-size: 14px;
  }
  
  .derslig-dialog-button {
    padding: 7px 14px;
    font-size: 13px;
  }
}
</style> 